<template lang="html">
  <div class="page">
    <div class="notification-loader" v-if="loader">
      <span>Carregando</span> <v-loader />
    </div>
    <slot></slot>
    <footer class="page-footer">
      Copyright © 2023. Vibbra
    </footer>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loader: false,
    };
  },
  props: {
    profile: String,
  },
  computed: {
    // theClass() {
    //   return 'page-' + this.profile
    // }
  },
  methods: {
    showMsg(type, v) {
      this.hideLoader();
      if (type == 'error') {
        this.showErrorMsg(v);
      }
    },
    showLoader() {
      this.loader = true;
    },
    hideLoader() {
      this.loader = false;
    },
  },
};
</script>

<style lang="scss">
.page {
  background-color: color('page-bg');
  min-height: 100vh;
  font-family: font(text);
  padding-top: 62px;
  position: relative;

  &:before {
    content: '';
    background-image: url('../../assets/background/fundoAzul.svg');
    background-repeat: no-repeat;
    background-size: cover;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%; /* Para garantir que a imagem fique atrás do conteúdo */
    opacity: 0.1
  }

  .notification-loader {
    position: fixed;
    top: 0;
    right: 0;
    z-index: 999999;
    display: flex;
    align-items: center;
    background-color: #fff;
    padding: 10px;
    .loader {
      padding: 0;
      margin-left: 10px;
      img {
        height: 32px;
        width: 32px;
      }
    }
  }
  .page-footer {
    text-align: center;
    font-size: 14px;
    padding: 30px 0 30px;
    margin-top: 70px;
    width: 100%;
  }
}
.mini-toastr {
  .mini-toastr__notification {
    opacity: 1;
    border-radius: 0.25rem;
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
    border: 2px solid #fff;
    .mini-toastr-notification__message {
      padding: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/parts/components/page.vue